
import dayjs from "dayjs";
export const todayFormatted = `${dayjs().format('dddd')} of ${dayjs().format('D MMMM, YYYY')}.`;